export default __webpack_public_path__ + "78d2d54bf9bd3cc9af6d2b5e3551a275.png";